module.exports = __webpack_public_path__ + "img/sld_mccb_box.3d6b9dbf.svg";